<template>
  <div class="common-function">
  
    <!-- <a class="function-li" href="./showCompany.html">
      <img src="@/assets/index_05.png" alt="">
      <p>企业展厅</p>
    </a> -->
    <div class="function-li" @click="openService">
      <img src="@/assets/kefu.png" alt="">
      <p>客服</p>
    </div>
    <div class="show">
    <img src="@/assets/t.png">
    </div>
    <!--  -->
    <el-popover
      placement="left"
      width="140"
      trigger="hover"
      >
      <div>
        <p>电话：xxx-xxxxxxxx</p>
        <p style="margin-top: 6px;">电话：xxx-xxxxx</p>
      </div>
      <div class="function-li" slot="reference">
        <img src="@/assets/phone.png" alt="">
        <p>电话</p>
      </div>
    </el-popover> 
    <!--  -->
  <!--  <el-popover-->
  <!--    placement="left"-->
  <!--    width="180"-->
  <!--    trigger="hover">-->
  <!--    <img src="@/assets/zsqEwm.jpg" alt="" style="width: 180px;height: 180px;">-->
  <!--    <div class="function-li" slot="reference">-->
  <!--      <img src="@/assets/xcx.png" alt="">-->
  <!--      <p>小程序</p>-->
  <!--    </div>-->
  <!--  </el-popover>-->
    <!--  -->
    <div class="function-li" @click="back">
      <img src="@/assets/back_top.png" alt="">
      <p>返回顶层</p>
    </div>
  
    <!-- 客服组件 -->
    <intelService  ref="intelService"/>
  </div>
    
  
</template>
<script>
/**
 * Component functionBlock 固定功能块组件
 	@author fanjun
 	@props data（必选属性前面带＊，非必选项目请备注默认值）
	@example
	<functionBlock/>
**/
import './index.scss'
import { Popover } from 'element-ui';
import IntelService from '@/components/newsComponents/intelService/index.vue'
export default {
  name: 'functionBlock',
  components:{
    [Popover.name]:Popover,
    IntelService
  },
  props:{

  },
  data(){
    return{
    }
  },
  methods: {
    back(){
      window.scrollTo({top:0, behavior: "smooth"})
    },
    // 打开智能客服
    openService(){
      this.$refs['intelService'].open();
    }
  }
}
</script>

